import api from './api';

const apiWithTags = api.enhanceEndpoints({
	addTagTypes: ['EnabledFlexCredentials', 'FlexCredentialByType']
});

const flexProfessionalCredentialsApi = apiWithTags.injectEndpoints({
	tagTypes: ['EnabledFlexCredentials'],
	endpoints: (build) => ({
		enabledFlexCredentials: build.query({
			query: ({ managementCompanyId, caregiverId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/credentials`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['EnabledFlexCredentials']
		}),
		flexCredentialByType: build.query({
			query: ({ caregiverId, credType, managementCompanyId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/credentials/${credType}`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['FlexCredentialByType']
		}),
		uploadFlexCredential: build.mutation({
			query: ({ caregiverId, credType, managementCompanyId, formData }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/credentials/${credType}`,
				method: 'POST',
				headers: { 'Content-Type': undefined, 'management-company-id': managementCompanyId },
				body: formData
			}),
			invalidatesTags: (result, error) => (error ? [] : ['FlexCredentialByType', 'EnabledFlexCredentials'])
		}),
		deleteFlexCredential: build.mutation({
			query: ({ caregiverId, credentialId, credentialType, managementCompanyId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/credentials/${credentialType}/${credentialId}`,
				method: 'DELETE',
				headers: { 'management-company-id': managementCompanyId }
			}),
			invalidatesTags: (result, error) => {
				if (!error) {
					return ['FlexCredentialByType', 'EnabledFlexCredentials'];
				}

				if (error?.data?.errors?.[0]?.reason === 'CREDENTIAL_NOT_FOUND') {
					return ['FlexCredentialByType', 'EnabledFlexCredentials'];
				}

				return [];
			}
		})
	})
});

export const {
	useEnabledFlexCredentialsQuery,
	useFlexCredentialByTypeQuery,
	useUploadFlexCredentialMutation,
	useDeleteFlexCredentialMutation
} = flexProfessionalCredentialsApi;
